import _ from 'lodash';
import React from 'react';
import dayjs from 'dayjs';
import DateFnsUtils from '@date-io/date-fns';

// Material UI
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl/FormControl';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

// Components
import { FormHelperText, FormInput } from '../_ui/forms.component';
import { FormikFieldLabel } from './formik-field-label.component';
import { FormikFieldCommonProps, useFormikField } from './use-formik-field';
import { timeToNum } from '../../../lib/helpers/conversion.helpers';
import styled from 'styled-components';

// formik-timepicker has no extra props of its own — it's the common base
// verbatim. Kept as an explicit alias rather than `React.FC<FormikFieldCommonProps>`
// so the name `IFormikTimePicker` still shows up in tooling / hovers.
interface IFormikTimePicker extends FormikFieldCommonProps {}

export const FormikTimePicker: React.FC<IFormikTimePicker> = ({
  field,
  fid,
  id,
  label,
  form,
  ...rest
}) => {
  const { id: _id, error, touched } = useFormikField({ field, form, fid, id });

  return (
    <FormControl margin="dense" fullWidth component="div" error={!!error && touched}>
      <FormikFieldLabel label={label} htmlFor={_id} hasError={!!touched && !!error} />
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardTimePicker
          id={_id}
          autoOk
          minutesStep={5}
          margin="normal"
          mask="__:__ _M"
          name={field.name}
          error={!!error && !!touched}
          value={dayjs().startOf('day').add(field.value, 'minute').toDate()}
          onChange={(value: MaterialUiPickersDate) => {
            if (value) {
              form.setFieldValue(field.name, timeToNum(dayjs(value).format('h:mm A')));
            }
          }}
          TextFieldComponent={TextFieldComponent}
        />
      </MuiPickersUtilsProvider>
      {touched && _.isString(error) && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
}

const AdornmentWrapper = styled.div`
  margin-right: 4px;
  padding: 3px 0px;

  & > .MuiInputAdornment-root {
    height: auto;
  }

   & > .MuiInputAdornment-positionEnd {
    margin-left: 0;
   }
`;

const TextFieldComponent = ({ error, helperText, ...props }: any) => {
  return (
    <Box>
      <Box display="flex" justifyContent="center">
        <AdornmentWrapper>
          {props.InputProps.endAdornment}
        </AdornmentWrapper>
        <FormInput {...props} $hasError={!!error} style={{ flexGrow: 1 }} />
      </Box>
      {helperText && <FormHelperText error>{helperText}</FormHelperText>}
    </Box>
  );
};
